// src/services/templateService.js
import { getApiConfig } from '../config/markets.js';

const API_URL = getApiConfig().apiUrl;

/**
 * Obtener templates disponibles para una conversación
 * @param {string} conversationId
 * @returns {Promise<{market: string, templates: Array}>}
 */
export async function getTemplatesByConversation(conversationId) {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_URL}/templates/${conversationId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
  });

  // 3) Si la respuesta no es OK, parsear mensaje de error
  if (!response.ok) {
    let errMsg = 'Error al obtener conversaciones';
    try {
      const data = await response.json();
      errMsg = data.message || errMsg;
    } catch {
      // Ignorar si no viene JSON
    }
    throw new Error(errMsg);
  }

  // 4) Si todo va bien, devolvemos el JSON con el array de conversaciones
  const templates = await response.json();
  return templates;
}

/**
 * Enviar template a una conversación
 * @param {string} conversationId
 * @param {string} templateId
 * @param {Object} variables - Variables del template { "1": "valor1", "2": "valor2" }
 * @returns {Promise<any>}
 */
export async function sendTemplate(conversationId, templateId, variables = {}) {
  const token = localStorage.getItem('token');

  const body = {
    conversationId,
    templateId,
    variables
  };

  const response = await fetch(`${API_URL}/templates/send`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || data.error || 'Error al enviar template');
  }

  return await response.json();
}
